let favoritesObserver = {
    init: function () {
        if (document.body.dataset.loggedin === 'true' && sessionStorage.vuex) {
            const addedDocuments = JSON.parse(sessionStorage.vuex).addedDocuments;

            if (addedDocuments) {
                let intersectionOptions = {
                    rootMargin: "100%",
                    threshold: [0]
                }

                const favoritesButtons = document.querySelectorAll("[data-favoriteid]");

                // Next we want to create a function that will be called when that element is intersected
                function favoritesButtonsIntersection(entries) {
                    // The callback will return an array of entries, even if you are only observing a single item
                    entries.map((entry) => {
                        if (entry.intersectionRatio > 0) {
                            const btn = entry.target;
                            const btnFaveId = btn.dataset.favoriteid;
                            btn.addEventListener("click", function () {
                                const favoriteId = document.getElementById("favoriteId");
                                favoriteId.value = btnFaveId;
                                var change = new Event('change');
                                favoriteId.dispatchEvent(change);
                            })
                            if (addedDocuments.includes(parseInt(btnFaveId))) {
                                btn.classList.add('in-list');
                            } else {
                                btn.classList.remove('in-list');
                            }

                            buttonObserver.unobserve(entry.target);
                        }
                    });
                }

                // Next we instantiate the observer with the function we created above. This takes an optional configuration
                // object that we will use in the other examples.
                const buttonObserver = new IntersectionObserver(favoritesButtonsIntersection, intersectionOptions);

                // Finally start observing the ribbon element
                favoritesButtons.forEach(el => buttonObserver.observe(el));

            }

        } else if(sessionStorage.vuex) {
            sessionStorage.removeItem('vuex');
        }
    }
}

export default favoritesObserver;